
export const ScoreBoard = () => {


    // const handleInput = async (file: File) => {
    //     // console.log("handleFileupload", file.name);
    //     // const json = await parseXmlToJson2(file);
    //     // console.log("JSON test:", json.TournamentResults);
    // }

    return (
        <>
            ScoreBoard
            {/* <img src={logo} alt="Badminton Smash logo" />
            <TextInput />
            <Button text="OK" />
            <br /><br /><br />
            <ButtonBlue text="Jeg har ikke en kode" /> */}
        </>
    )
}

// const Root = styled.div`
//     display: flex;
//     flex-direction: column;
//     // align-items: center;
//     color: #829DA3;
//     text-decoration: none;
//     margin-bottom: 24px;
//     font-size: 11px;
//     transition: 0.25s;
// `;

// const Title = styled.h2`
//     margin: 0 0 16px 0;
//     color: white;
// `;